import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectIsAuthenticated, selectIsAuthLoading } from '../../state/auth.slice'
import LoadingPage from '../ui/LoadingPage'

const PublicRoute = ({ children }) => {
  const navigate = useNavigate()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const isAuthLoading = useSelector(selectIsAuthLoading)

  useEffect(() => {
    // If auth is still loading, don't redirect - let the loading screen show
    if (isAuthLoading) {
      return
    }

    // If authenticated, redirect to home
    if (isAuthenticated) {
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, isAuthLoading, navigate])

  // If auth is still loading, show loading screen
  if (isAuthLoading) {
    return (
      <LoadingPage
        title="Checking Authentication"
        subtitle="Please wait while we check your login status"
      />
    )
  }

  // If authenticated, don't render children (will redirect)
  if (isAuthenticated) {
    return null
  }

  // If not authenticated, render children
  return children
}

export default PublicRoute
